//tag_no	pet_no	client_no	assign_date	done_date
export class PetTagHistModel {
    id: number
    tag_no: string
    pet_no: number
    pet_name: string
    client_no: number
    assign_date: string
    done_date: string 
    location: string 
    sublocation: number 
    duration: number 
    status: string 
    department: string 
    done_by:string

    constructor(
        id: number,
        tag_no: string,
        pet_no: number,
        pet_name: string,
        client_no: number,
        assign_date: string,
        done_date: string,
        location: string,
        sublocation: number,
        duration: number,
        status: string,
        department: string,
        done_by:string

    ) { 
        this.id = id
        this.tag_no = tag_no
        this.pet_no = pet_no 
        this.pet_name = pet_name 
        this.client_no = client_no 
        this.assign_date = assign_date 
        this.done_date = done_date 
        this.location = location 
        this.sublocation = sublocation 
        this.duration = duration 
        this.status = status 
        this.department = department 
        this.done_by = done_by
    }


}